// Soul System（system/、/api/v1/...）につなぐ。返す形は App（./app.js）にそろえる。
import i18n from "i18n";
import { contentWorkOf } from "constants/works";
import {
  getSystemTicketState,
  listSystemQuests,
  listSystemTickets,
  purchaseSystemTicketStripe,
  purchaseSystemTicketPaypay,
  getSystemUnconfirmedPayment,
  getPayPayPaymentStatus,
  getSystemUserEmail,
  updateSystemUserEmail,
  getSystemGuidelinesAgreement,
  postSystemGuidelinesAgreement,
} from "utils/api";

// System は Soul の顔（名前・説明・画像）を持たない。作品の文言と、Sekai の素材の置き場所から作る。
// 画像は system/sekai/<sekai>/souls/<soul>/content_images/portrait.jpg を同期した先。
const soulFace = (work, soulId) => {
  const soul = soulId.split("_")[0];
  const content = contentWorkOf(work);
  return {
    name: i18n.t(`${content}:character.${soul}`),
    description: i18n.t(`${content}:soulDescription.${soul}`),
    eye_catch_url: `/assets/${work}/content_images/${soul}/portrait.jpg`,
  };
};

const unsupported = () =>
  Promise.reject(new Error("Not supported by the Soul System"));

export const systemBackend = (work) => ({
  kind: "system",

  // 未購入なら null
  getEpisode: async (soulId) => {
    let state;
    try {
      state = await getSystemTicketState(soulId);
    } catch (error) {
      if (error.status === 404) return null;
      throw error;
    }
    return {
      ...soulFace(work, soulId),
      ticket_key: state.ticket_key,
      expire_at: state.expires_at,
      is_expired: state.is_expired,
      can_extend: Boolean(state.can_extend) && !state.is_expired,
      // リセットは System の共通ルール（待ち時間なし・1種類）
      can_reset: true,
      has_reset_options: false,
      can_soft_reset: false,
      mode_info: { supports_mode_switch: false },
    };
  },

  listQuestGroups: async (soulId) => (await listSystemQuests(soulId)).data,

  listTickets: async (soulId) =>
    (await listSystemTickets(soulId)).data.map((ticket) => ({
      ...ticket,
      currency_code: ticket.currency,
      is_continuation: ticket.type === "continue",
    })),

  // 価格は画面に出したもの。変わっていれば 422 で止まる
  purchaseWithStripe: (soulId, ticket) =>
    purchaseSystemTicketStripe(soulId, ticket.ticket_key, ticket.price),

  purchaseWithPaypay: async (soulId, ticket) => {
    const { url } = await purchaseSystemTicketPaypay(
      soulId,
      ticket.ticket_key,
      ticket.price
    );
    return { url };
  },

  getUnconfirmedPaypay: async (soulId) =>
    (await getSystemUnconfirmedPayment(soulId)).unconfirmed_payment || null,

  getPaypayStatus: (merchantPaymentId, options = {}) =>
    getPayPayPaymentStatus(merchantPaymentId, { ...options, useSystemApi: true }),

  getEmail: () => getSystemUserEmail(),
  updateEmail: (emailAddress, disableMailDelivery) =>
    updateSystemUserEmail(emailAddress, disableMailDelivery),

  getGuidelinesAgreement: (soulId) => getSystemGuidelinesAgreement(soulId),
  agreeGuidelines: (soulId) => postSystemGuidelinesAgreement(soulId),

  scheduleModeSwitch: unsupported,
  unscheduleModeSwitch: unsupported,
});
